import { API_BASE_URL } from '../config';

export async function fetchPublicEditorialContent(tag) {
  const q = tag ? `?tag=${encodeURIComponent(tag)}` : '';
  const res = await fetch(`${API_BASE_URL}/public/editorial-content${q}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to load content');
  return data.items || [];
}

export function getAdminHeaders() {
  const token = localStorage.getItem('adminToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function fetchAllEditorialContent() {
  const res = await fetch(`${API_BASE_URL}/admin/editorial-content`, {
    headers: getAdminHeaders(),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to load');
  return data.items || [];
}

export async function createEditorialItem(body) {
  const res = await fetch(`${API_BASE_URL}/admin/editorial-content`, {
    method: 'POST',
    headers: getAdminHeaders(),
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.details || 'Create failed');
  return data.item;
}

export async function updateEditorialItem(id, body) {
  const res = await fetch(`${API_BASE_URL}/admin/editorial-content/${id}`, {
    method: 'PATCH',
    headers: getAdminHeaders(),
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.details || 'Update failed');
  return data.item;
}

export async function deleteEditorialItem(id) {
  const res = await fetch(`${API_BASE_URL}/admin/editorial-content/${id}`, {
    method: 'DELETE',
    headers: getAdminHeaders(),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Delete failed');
  return data;
}
